import type { MisconceptionDefinition } from '../types';
export const oppervlakteMisconceptions: MisconceptionDefinition[] = [{
  id: 'met.opp-stap-factor-10',
  label: 'Oppervlakte met factor 10 i.p.v. 100',
  module: 'Metriek',
  description: 'Leerling gebruikt factor 10 per trede bij oppervlakte-omrekening (cm² → dm²) in plaats van factor 100 (kwadraat van 10).',
  typicalFamilies: ['MET-OPP-OMREKENEN', 'MET-OPP-LAND']
}, {
  id: 'met.opp-stap-factor-1000',
  label: 'Oppervlakte met factor 1000 i.p.v. 100',
  module: 'Metriek',
  description: 'Leerling gebruikt factor 1.000 per trede bij oppervlakte-omrekening (verwart met kubieke maten) in plaats van factor 100.',
  typicalFamilies: ['MET-OPP-OMREKENEN', 'MET-OPP-LAND']
}, {
  id: 'met.opp-richting-omgedraaid',
  label: 'Richting omgedraaid bij oppervlakte-omrekening',
  module: 'Metriek',
  description: 'Leerling vermenigvuldigt waar gedeeld moet worden (of andersom) bij oppervlakte-omrekening — vergelijkbaar met lineaire trapfout.',
  typicalFamilies: ['MET-OPP-OMREKENEN', 'MET-OPP-LAND']
}, {
  id: 'met.opp-richting-fout',
  label: 'Richting fout bij ha/m²/km²',
  module: 'Metriek',
  description: 'Leerling vermenigvuldigt of deelt in de verkeerde richting tussen m², hectare en km².',
  typicalFamilies: ['MET-OPP-LAND', 'MET-OPP-OMREKENEN']
}, {
  id: 'met.opp-stap-te-weinig',
  label: 'Te weinig stappen op de trap',
  module: 'Metriek',
  description: 'Leerling neemt te weinig stappen op de oppervlakte-trap (bijv. één stap i.p.v. twee), waardoor de omrekenfactor te klein is.',
  typicalFamilies: ['MET-OPP-OMREKENEN', 'MET-OPP-LAND']
}, {
  id: 'met.opp-stap-te-veel',
  label: 'Te veel stappen op de trap',
  module: 'Metriek',
  description: 'Leerling neemt te veel stappen op de oppervlakte-trap, waardoor de omrekenfactor te groot wordt (bijv. ÷100.000 i.p.v. ÷10.000).',
  typicalFamilies: ['MET-OPP-OMREKENEN', 'MET-OPP-LAND']
}, {
  id: 'met.parallellogram-schuine-zijde-vs-hoogte',
  label: 'Schuine zijde i.p.v. hoogte gebruikt',
  module: 'Metriek',
  description: 'Leerling gebruikt de schuine zijde van het parallellogram als hoogte in de oppervlakteformule i.p.v. de loodrechte hoogte.',
  typicalFamilies: ['MET-OPP-PARALLELLOGRAM']
}, {
  id: 'met.parallellogram-driehoek-formule',
  label: 'Driehoekformule op parallellogram',
  module: 'Metriek',
  description: 'Leerling past de driehoek-formule (basis × hoogte ÷ 2) toe op een parallellogram, terwijl de parallellogram-formule géén deling door 2 heeft.',
  typicalFamilies: ['MET-OPP-PARALLELLOGRAM']
}, {
  id: 'met.parallellogram-alle-zijden-gebruikt',
  label: 'Gebruikt alle zijden van parallellogram',
  module: 'Metriek',
  description: 'Leerling denkt dat alle vier de zijden nodig zijn voor de oppervlakte van een parallellogram, i.p.v. alleen basis en hoogte.',
  typicalFamilies: ['MET-OPP-PARALLELLOGRAM']
}, {
  id: 'met.parallellogram-conceptueel-onbegrepen',
  label: 'Onbegrepen reden parallellogram-formule',
  module: 'Metriek',
  description: 'Leerling kan de formule basis × hoogte voor parallellogram niet conceptueel onderbouwen (waarom géén ÷ 2, of waarom hoogte i.p.v. zijde).',
  typicalFamilies: ['MET-OPP-PARALLELLOGRAM']
}, {
  id: 'met.opp-optellen-ipv-vermenigvuldigen',
  label: 'Optellen i.p.v. vermenigvuldigen',
  module: 'Metriek',
  description: 'Leerling telt de afmetingen op i.p.v. te vermenigvuldigen — verwart oppervlakte met omtrek of past de verkeerde bewerking toe.',
  typicalFamilies: ['MET-OPP-DRIEHOEK', 'MET-OPP-PARALLELLOGRAM', 'MET-OPP-VIERKANT', 'MET-OPP-RECHT']
}, {
  id: 'met.opp-delen-door-2-vergeten',
  label: 'Vergeten te delen door 2 (driehoek)',
  module: 'Metriek',
  description: 'Leerling berekent basis × hoogte voor een driehoek maar vergeet door 2 te delen, en krijgt zo de oppervlakte van een rechthoek.',
  typicalFamilies: ['MET-OPP-DRIEHOEK']
}, {
  id: 'met.opp-verkeerde-afmeting',
  label: 'Verkeerde afmeting gebruikt',
  module: 'Metriek',
  description: 'Leerling gebruikt een verkeerde afmeting in de oppervlakteformule (bijv. een schuine zijde, omtrek-deel, of niet-passende lijn).',
  typicalFamilies: ['MET-OPP-DRIEHOEK', 'MET-OPP-PARALLELLOGRAM', 'MET-OPP-VIERKANT']
}, {
  id: 'met.opp-dubbel-gedeeld-door-2',
  label: 'Twee keer door 2 gedeeld',
  module: 'Metriek',
  description: 'Leerling deelt twee keer door 2 bij een driehoek-berekening — overgeneralisatie van de ÷2-regel.',
  typicalFamilies: ['MET-OPP-DRIEHOEK']
}, {
  id: 'met.opp-beide-afmetingen-verdubbeld',
  label: 'Beide afmetingen verdubbeld',
  module: 'Metriek',
  description: 'Leerling denkt dat bij verdubbeling van één afmeting beide afmetingen verdubbelen, of verdubbelt de oppervlakte twee keer.',
  typicalFamilies: ['MET-OPP-DRIEHOEK', 'MET-OPP-PARALLELLOGRAM']
}, {
  id: 'met.opp-verkeerde-verhouding',
  label: 'Verkeerde verhouding bij schaling',
  module: 'Metriek',
  description: 'Leerling past de verkeerde verhouding toe bij vergroten/verkleinen van een oppervlakte (bijv. ×2 i.p.v. ×4 bij verdubbeling van zijde).',
  typicalFamilies: ['MET-OPP-DRIEHOEK', 'MET-SCHAAL-OPP']
}, {
  id: 'met.opp-omtrek-verward',
  label: 'Oppervlakte met omtrek verward',
  module: 'Metriek',
  description: 'Leerling rekent omtrek uit waar oppervlakte gevraagd is (of omgekeerd) — verwart de twee maten.',
  typicalFamilies: ['MET-OPP-PARALLELLOGRAM', 'MET-OPP-VIERKANT', 'MET-OPP-RECHT', 'MET-OMTREK-RECHT']
}, {
  id: 'met.opp-formule-overgegeneraliseerd',
  label: 'Oppervlakte-formule overgegeneraliseerd',
  module: 'Metriek',
  description: 'Leerling past één oppervlakte-formule toe op alle vierhoeken zonder onderscheid (bijv. ÷ 2 voor rechthoek, of basis×hoogte voor trapezium).',
  typicalFamilies: ['MET-OPP-PARALLELLOGRAM', 'MET-OPP-SAMENGESTELD']
}, {
  id: 'met.opp-regel-niet-begrepen',
  label: 'Oppervlakte-omrekenregel niet begrepen',
  module: 'Metriek',
  description: 'Leerling past de ×100-regel mechanisch toe zonder te begrijpen dat oppervlakte twee dimensies omrekent — verwart "twee keer omrekenen" met "twee dimensies".',
  typicalFamilies: ['MET-OPP-OMREKENEN']
}, {
  id: 'met.opp-rekenfout',
  label: 'Rekenfout in oppervlakte-vermenigvuldiging',
  module: 'Metriek',
  description: 'Leerling past de juiste oppervlakte-formule toe maar maakt een rekenfout in de vermenigvuldiging.',
  typicalFamilies: ['MET-OPP-VIERKANT', 'MET-OPP-RECHT']
}, {
  id: 'met.opp-zijde-verward',
  label: 'Oppervlakte met zijde verward',
  module: 'Metriek',
  description: 'Leerling geeft een zijde-lengte op als oppervlakte, of omgekeerd, bij terugrekenen.',
  typicalFamilies: ['MET-OPP-VIERKANT']
}, {
  id: 'met.opp-wortel-fout',
  label: 'Fout in worteltrekken (zijde uit oppervlakte)',
  module: 'Metriek',
  description: 'Leerling maakt een fout bij worteltrekken om de zijde van een vierkant uit de oppervlakte te bepalen.',
  typicalFamilies: ['MET-OPP-VIERKANT']
}, {
  id: 'met.opp-delen-door-2-ipv-wortel',
  label: 'Door 2 delen i.p.v. wortel trekken',
  module: 'Metriek',
  description: 'Leerling deelt de oppervlakte door 2 om de zijde van een vierkant te vinden i.p.v. de vierkantswortel te nemen.',
  typicalFamilies: ['MET-OPP-VIERKANT']
}, {
  id: 'met.omtrek-aantal-zijden-vierkant',
  label: 'Verkeerd aantal zijden bij omtrek',
  module: 'Metriek',
  description: 'Leerling telt slechts één paar zijden op (l + b) of vergeet een zijde — krijgt bijvoorbeeld 16 i.p.v. 32 voor een 12×4 rechthoek.',
  typicalFamilies: ['MET-OMTREK-RECHT', 'MET-MEETK-OMTREK']
}, {
  id: 'met.omtrek-aantal-zijden-fout',
  label: 'Fout aantal zijden bij omtrek-berekening',
  module: 'Metriek',
  description: 'Leerling gebruikt het verkeerde aantal zijden bij het optellen van de omtrek (bijv. 3 zijden i.p.v. 4, of de breedte maar één keer geteld).',
  typicalFamilies: ['MET-OMTREK-RECHT', 'MET-MEETK-OMTREK']
}, {
  id: 'met.omtrek-terugrekenen-fout',
  label: 'Fout bij omtrek terugrekenen',
  module: 'Metriek',
  description: 'Leerling deelt de gegeven omtrek niet eerst door 2 (of vergeet de lengte af te trekken) bij het terugrekenen van een ontbrekende zijde.',
  typicalFamilies: ['MET-OMTREK-RECHT', 'MET-OPP-RECHT']
}, {
  id: 'met.omtrek-vierkant-deler-fout',
  label: 'Vierkant-omtrek door verkeerd getal gedeeld',
  module: 'Metriek',
  description: 'Leerling deelt de omtrek van een vierkant door 2, 3 of 6 in plaats van door 4 om één zijde te krijgen — verwart het aantal zijden.',
  typicalFamilies: ['MET-OMTREK-RECHT']
}, {
  id: 'met.opp-langste-zijde-aanname',
  label: 'Langste zijde = grootste oppervlakte aangenomen',
  module: 'Metriek',
  description: 'Leerling kiest bij vergelijken de rechthoek met de langste zijde als grootste oppervlakte, zonder l × b uit te rekenen.',
  typicalFamilies: ['MET-OPP-RECHT']
}, {
  id: 'met.opp-hectare-100',
  label: '1 hectare als 100 m²',
  module: 'Metriek',
  description: 'Leerling denkt dat 1 hectare gelijk is aan 100 m² (verwart hectare met are).',
  typicalFamilies: ['MET-OPP-LAND']
}, {
  id: 'met.opp-are-10',
  label: '1 are als 10 m²',
  module: 'Metriek',
  description: 'Leerling denkt dat 1 are gelijk is aan 10 m² i.p.v. 100 m² — onderschat de are met factor 10.',
  typicalFamilies: ['MET-OPP-LAND']
}, {
  id: 'met.opp-are-1000',
  label: '1 are als 1000 m²',
  module: 'Metriek',
  description: 'Leerling denkt dat 1 are gelijk is aan 1000 m² i.p.v. 100 m² — overschat de are met factor 10.',
  typicalFamilies: ['MET-OPP-LAND']
}, {
  id: 'met.opp-are-gelijk-aan-m2',
  label: 'Are en m² als gelijk behandeld',
  module: 'Metriek',
  description: 'Leerling behandelt are en m² alsof het dezelfde eenheid is, zonder omrekening.',
  typicalFamilies: ['MET-OPP-LAND']
}, {
  id: 'met.opp-km2-ha-10',
  label: '1 km² als 10 hectare',
  module: 'Metriek',
  description: 'Leerling denkt dat 1 km² gelijk is aan 10 hectare i.p.v. 100 hectare.',
  typicalFamilies: ['MET-OPP-LAND']
}, {
  id: 'met.opp-km2-ha-1000',
  label: '1 km² als 1000 hectare',
  module: 'Metriek',
  description: 'Leerling denkt dat 1 km² gelijk is aan 1000 hectare i.p.v. 100 hectare — overschat met factor 10.',
  typicalFamilies: ['MET-OPP-LAND']
}, {
  id: 'met.opp-ha-gelijk-aan-km2',
  label: 'Hectare en km² als gelijk behandeld',
  module: 'Metriek',
  description: 'Leerling behandelt hectare en km² alsof het dezelfde eenheid is, zonder omrekening tussen de twee.',
  typicalFamilies: ['MET-OPP-LAND']
}, {
  id: 'met.samengesteld-deel-vergeten',
  label: 'Eén deel vergeten bij samengestelde figuur',
  module: 'Metriek',
  description: 'Leerling berekent de oppervlakte van slechts één deel van een samengestelde figuur en vergeet de andere delen op te tellen.',
  typicalFamilies: ['MET-OPP-SAMENGESTELD']
}, {
  id: 'met.samengesteld-buitenmaten-aannemen',
  label: 'Buitenmaten als volle rechthoek aangenomen',
  module: 'Metriek',
  description: 'Leerling behandelt een samengestelde figuur (L-, T-, U-vorm) als een volle rechthoek met buitenmaten, zonder rekening te houden met openingen of inkepingen.',
  typicalFamilies: ['MET-OPP-SAMENGESTELD']
}, {
  id: 'met.samengesteld-getallen-vermenigvuldigen',
  label: 'Alle getallen vermenigvuldigd i.p.v. delen optellen',
  module: 'Metriek',
  description: 'Leerling vermenigvuldigt alle afmetingen door elkaar in plaats van elke deel-oppervlakte apart te berekenen en daarna op te tellen.',
  typicalFamilies: ['MET-OPP-SAMENGESTELD']
}, {
  id: 'met.samengesteld-gat-niet-afgetrokken',
  label: 'Gat niet afgetrokken bij aftrekmethode',
  module: 'Metriek',
  description: 'Leerling berekent het grote geheel maar vergeet de uitsparing (gat, schuurtje, opening) eraf te trekken bij een samengestelde figuur met uitsparing.',
  typicalFamilies: ['MET-OPP-SAMENGESTELD']
}, {
  id: 'met.samengesteld-alleen-gat',
  label: 'Alleen het gat berekend',
  module: 'Metriek',
  description: 'Leerling berekent alleen de oppervlakte van het gat/de uitsparing in plaats van het overgebleven gebied (geheel − uitsparing).',
  typicalFamilies: ['MET-OPP-SAMENGESTELD']
}, {
  id: 'met.samengesteld-optellen-ipv-aftrekken',
  label: 'Gat opgeteld i.p.v. afgetrokken',
  module: 'Metriek',
  description: 'Leerling telt de oppervlakte van het gat op bij het geheel in plaats van eraf te trekken bij een aftrek-methode-figuur.',
  typicalFamilies: ['MET-OPP-SAMENGESTELD']
}, {
  id: 'met.opp-als-zijde-keer-2',
  label: 'Oppervlakte berekend als zijde × 2',
  module: 'Metriek',
  description: 'Leerling rekent de oppervlakte van een vierkant uit als zijde × 2 i.p.v. zijde × zijde (verwart kwadrateren met verdubbelen).',
  typicalFamilies: ['MET-OPP-VIERKANT', 'GET-MACHT']
}, {
  id: 'met.opp-als-omtrek',
  label: 'Oppervlakte verward met omtrek',
  module: 'Metriek',
  description: 'Leerling rekent de omtrek (4 × zijde) uit i.p.v. de oppervlakte (zijde × zijde) van een vierkant.',
  typicalFamilies: ['MET-OPP-VIERKANT', 'GET-MACHT']
}, {
  id: 'met.opp-hectare-1000',
  label: '1 hectare als 1000 m²',
  module: 'Metriek',
  description: 'Leerling denkt dat 1 hectare gelijk is aan 1.000 m² i.p.v. 10.000 m² — onderschat de hectare met factor 10.',
  typicalFamilies: ['MET-OPP-LAND']
}, {
  id: 'met.opp-hectare-100000',
  label: '1 hectare als 100.000 m²',
  module: 'Metriek',
  description: 'Leerling denkt dat 1 hectare gelijk is aan 100.000 m² i.p.v. 10.000 m² — overschat de hectare met factor 10.',
  typicalFamilies: ['MET-OPP-LAND']
}, {
  id: 'met.opp-m2-naar-ha-fout',
  label: 'Fout bij m² → ha conversie',
  module: 'Metriek',
  description: 'Leerling maakt een fout bij het omrekenen van vierkante meter naar hectare (1 ha = 10.000 m²).',
  typicalFamilies: ['MET-OPP-LAND']
}];